import { Spine } from 'pixi-spine'
import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'
import { assets } from 'utils/AssetParser'

export default class CascadeWinBox extends PIXI.Container {
  constructor(data) {
    super()
    this._data = data
    this.boxes = {}
    this.boxesContainer = new PIXI.Container()
    this.addChild(this.boxesContainer)
    this.init()
    signal.on('CURRENT-CASCADE', (currentCascade) => {
      this.playWin(currentCascade)
    })
  }

  init() {
    for (let i = 0; i <= reelsSettings.matrixX; i++) {
      for(let j = 0; j <= reelsSettings.matrixY; j++) {
        const box = new Spine(assets.spine[this._data.select].spineData)

        box.x = i * reelsSettings.items.width / 2
        box.y = j * reelsSettings.items.height / 2
        box.scale.set(this._data.scale)
        box.positionX = i
        box.positionY = j

        this.boxesContainer.addChild(box)

        const boxKey = this.getBoxKey(i, j)
        this.boxes[boxKey] = box
      }
    }
  }

  playWin(currentCascade) {
    let positions = game.models.CascadeModel.get().positions
    positions[currentCascade].forEach(([posX, posY]) => {
      const boxKey = this.getBoxKey(posX, posY)
      const box = this.boxes[boxKey]
      box.state.setAnimation(0, this._data.animation, false)
    })
  }

  getBoxKey(x, y) {
    return `x${x}-y${y}`
  }
}
